import { createFileRoute } from '@tanstack/react-router';
import { VerifyEmailHandler } from './verify.$token';

export const Route = createFileRoute('/verify/')({
  validateSearch: (search: Record<string, unknown>): { token?: string } => ({
    token: typeof search.token === 'string' ? search.token : undefined,
  }),
  component: VerifyByQuery,
});

function VerifyByQuery() {
  const { token } = Route.useSearch();
  return <VerifyEmailHandler token={token} />;
}
